module.exports = ".mat-paginator-page-size {\n  display: none !important;\n}\n\n.mat-paginator-range-label {\n  margin: 0 5px 0 0px !important;\n}\n\n.mat-32 {\n  /*color: #888 !important;*/\n}\n\n.app-loader {\n  width: 30px;\n  /*position: fixed;*/\n  bottom: 40px;\n  right: 40px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/employee-search/employee-search.component.css
// module id = ./src/app/components/employee-search/employee-search.component.css
// module chunks = main